import React from 'react'
import { Button, Icon } from 'semantic-ui-react'


function UserActionButton(props) {
    let handleOpenEdit = () => {
        props.agGridReact.props.getEditUserDetials(props.data)
    }
    return (
        <>
            <Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="pencil" color="blue" /></Button>
        </>
    )
}

export default UserActionButton
